/* import __COLOCATED_TEMPLATE__ from './magnifying-glass.hbs.js'; */
var _dec, _class;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { computed, set } from '@ember/object';
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';

/**
## Svgs::MagnifyingGlass

Displays an SVG of a magnifying glass. Black lines on transparent background.

### Example usage
hbs```
  <Svgs::MagnifyingGlass
    @isFocused={{isFocused}}
  />
```
*/

const DEFAULT_ICON_HEX = '#b3b3b3';
const MARKET_BLUE_HEX = '#006AFF';
let MagnifyingGlass = (_dec = computed('_defaultColor', 'isFocused'), (_class = class MagnifyingGlass extends SvgIcon {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "height", 20);
    _defineProperty(this, "width", 20);
    _defineProperty(this, "viewBox", '0 0 20 20');
    _defineProperty(this, "isFocused", false);
    _defineProperty(this, "fill", 'none');
    // Inherited from SvgIcon base class, this adds a class that interferes with
    // SVG styling
    _defineProperty(this, "colorClass", null);
  }
  get defaultColor() {
    if (this._defaultColor !== undefined) {
      return this._defaultColor;
    }
    return this.isFocused ? MARKET_BLUE_HEX : DEFAULT_ICON_HEX;
  }
  set defaultColor(value) {
    set(this, '_defaultColor', value);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "defaultColor", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "defaultColor"), _class.prototype)), _class));
export { MagnifyingGlass as default };